import { render } from "./ImageThumbnail.vue?vue&type=template&id=da4a2f48"
import script from "./ImageThumbnail.vue?vue&type=script&lang=js"
export * from "./ImageThumbnail.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__